export default "__VITE_ASSET__CwZSDKkW__"